import { memoSanitize } from '@axa-asia/emma-safely-set-inner-html';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import CustomerProfileTitle from '../../components/CustomerProfileTitle';
import LoadingView from '../../../../components/LoadingView';
import { EmmaFactory } from '@axa-asia/hk-emma-js';
import { isApp, resolveLocalizedText } from '../../../../utils';
import {
  getAccessCustState,
  getAccessIsLoading,
  getDeactivationCustState,
  getError,
  getInsuredAccessLabels,
  getInsuredPolicyList,
  getIsLoading,
} from '../../selectors/insuredAccessSelector';
import {
  fetchInsuredPolicyDetail,
  fetchInsuredPolicyList,
  resetInsuredAccessPage,
  updateInsuredAccess,
  fetchInsuredAccessLastUpdated,
} from '../../actions/insuredAccessAction';
import {
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
} from '@axa-asia/emma-stylesheet/lib/components/Dialog';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@axa-asia/emma-stylesheet/lib/components/Modal';
import { CustomerProfileError } from '../../components/CustomerProfileError';
import { InsuredAccessCard } from '../../components/InsuredAccessCard';
import { goto, goToView } from '../../../../actions/historyActions';
import _ from 'lodash';
import './style.scss';
import {
  postRnDeeplinkAction,
  hideBackButton,
  showBackButton,
  showCloseButton,
  hideCloseButton,
  controlTopbarOverlay,
} from '../../../../utils/AppUtils';
import { INSURED_SHARE } from '../../actions/modalAction';
import {
  trackInsuredAccess,
  TrackInsuredAccessAction,
  trackPartnerServiceDisclaimer,
  TrackPartnerServiceDisclaimerIcon,
  trackRemindInsured,
  TrackRemindInsuredAction,
} from '../../../../utils/generalGaEventAnalytics';
import loadingIcon from '../../../../assets/images/loading-white.png';
import EmmaErrorModal from '../../../../components/EmmaErrorModal';

export interface InsuredAccessContainerProps {
  insuredAccessLabels: any;
  policyList: Array<any>;
  isLoading: boolean;
  accessIsLoading: boolean;
  accessCustState: any;
  deactivationCustState: any;
  error: boolean;
  fetchInsuredPolicyList: () => void;
  updateInsuredAccess: (
    policyNumber: string,
    insuredAccessFlag: string,
    custKey: string,
    callback: () => void,
  ) => void;
  resetInsuredAccessPage: () => void;
  fetchInsuredPolicyDetail: (policyNumber: string, entityCode: string) => void;
  showInsuredShare: () => void;
  fetchInsuredAccessLastUpdated: (custKey: string, destination: string) => void;
}

export interface InsuredAccessContainerState {
  tncModal: boolean;
  deauthorizeTncModal: boolean;
  deauthorizeReasonModal: boolean;
  selectedPolicy: string;
  deauthorizePolicy: string;
  showMenu: string;
  agreeLoseAxaGoalData: boolean;
  agreeClaimSubmission: boolean;
  agreeAssistInsured: boolean;
  reasonRadio: string;
}

export class InsuredAccessContainer extends Component<
  InsuredAccessContainerProps,
  InsuredAccessContainerState
> {
  statusInterval?: NodeJS.Timer;

  constructor(props: any) {
    super(props);
    this.state = {
      tncModal: false,
      deauthorizeTncModal: false,
      deauthorizeReasonModal: false,
      selectedPolicy: '',
      deauthorizePolicy: '',
      showMenu: '',
      agreeLoseAxaGoalData: false,
      agreeClaimSubmission: false,
      agreeAssistInsured: false,
      reasonRadio: '',
    };
  }

  resetPage = () => {
    const { resetInsuredAccessPage, fetchInsuredPolicyList } = this.props;

    resetInsuredAccessPage();
    fetchInsuredPolicyList();
  };

  onExpand = (policyNumber: string, entityCode: string, policyDetail: any) => {
    const { fetchInsuredPolicyDetail } = this.props;

    if (_.isEmpty(policyDetail)) {
      fetchInsuredPolicyDetail(policyNumber, entityCode);
    }

    if (this.state.showMenu) {
      this.setState({ showMenu: '' });
    }
  };

  handleContactUs = () => {
    if (isApp()) {
      goToView('emma-life/generic-support');
    } else {
      goto('emma-life/generic-support');
    }
  };

  handleAuthorize = (policyNumber: string) => {
    trackInsuredAccess(TrackInsuredAccessAction.AUTHORIZED, policyNumber);

    this.setState({
      tncModal: true,
      selectedPolicy: policyNumber,
    });

    controlTopbarOverlay(true);
    hideBackButton();
    hideCloseButton();
  };

  handleDeauthorize = (policyNumber: string) => {
    trackInsuredAccess(TrackInsuredAccessAction.DEAUTHORIZED, policyNumber);
    this.setState({
      deauthorizeTncModal: true,
      deauthorizePolicy: policyNumber,
    });

    controlTopbarOverlay(true);
    hideBackButton();
    hideCloseButton();
  };

  handleMenu = (policyNumber: string) => {
    this.setState({ showMenu: policyNumber });
  };

  handleSharing = (policyNumber: string, insuredAccessFlag: string) => {
    // sharing in mobile
    const result = postRnDeeplinkAction({
      host: 'emma-common/shareTemplate',
      query: {
        templateId: 'insuredInvitation',
      },
    });
    if (!result) {
      // handle web behaviour
      const { showInsuredShare } = this.props;
      showInsuredShare();
    }

    trackRemindInsured(
      insuredAccessFlag === 'Y'
        ? TrackRemindInsuredAction.ACTIVATED
        : TrackRemindInsuredAction.PENDING,
      policyNumber,
    );
  };

  onChangeCheckbox = (event: any) => {
    this.setState({
      [event.target.name]: event.target.checked,
    } as any);
  };

  onChangeRadio = (event: any) => {
    this.setState({
      [event.target.name]: event.target.value,
    } as any);
  };

  componentDidMount() {
    const {
      fetchInsuredPolicyList,
      fetchInsuredAccessLastUpdated,
      insuredAccessLabels,
      policyList,
    } = this.props;
    const { insuredAccessCustKey, deactivationCustKey, statusRefreshTime } =
      insuredAccessLabels;

    if (_.isEmpty(policyList)) {
      fetchInsuredPolicyList();
    }

    fetchInsuredAccessLastUpdated(insuredAccessCustKey, 'accessCustState');
    fetchInsuredAccessLastUpdated(deactivationCustKey, 'deactivationCustState');

    // set interval to update policy list access status
    this.statusInterval = setInterval(() => {
      fetchInsuredPolicyList();
    }, statusRefreshTime);

    if (isApp()) {
      const { pageTitle } = insuredAccessLabels;
      const title = pageTitle ? resolveLocalizedText(pageTitle) : '';
      if (title) {
        EmmaFactory.createInstance().then((p) =>
          p.instance.setNavigationTitle(title),
        );
      }
    }
  }

  componentWillUnmount() {
    if (this.statusInterval) {
      clearInterval(this.statusInterval);
    }
  }

  render() {
    const {
      insuredAccessLabels,
      policyList,
      isLoading,
      accessIsLoading,
      accessCustState,
      deactivationCustState,
      error,
      updateInsuredAccess,
    } = this.props;
    const {
      tncModal,
      selectedPolicy,
      deauthorizePolicy,
      showMenu,
      deauthorizeTncModal,
      deauthorizeReasonModal,
      agreeLoseAxaGoalData,
      agreeClaimSubmission,
      agreeAssistInsured,
      reasonRadio,
    } = this.state;
    const {
      pageTitle,
      policyListHeader,
      policyListDesc,
      tncModalTitle,
      tncModalContent,
      tncModalAgreeBtn,
      tncModalCancelBtn,
      deauthorizeTncModalTitle,
      deauthorizeTncModalDesc,
      agreeLoseAxaGoalDataLabel,
      agreeClaimSubmissionLabel,
      agreeAssistInsuredLabel,
      insuredAccessCustKey,
      deactivationCustKey,
      deauthorizeReasonModalTitle,
      reasonMistakeLabel,
      reasonLossDeviceLabel,
      reasonPersonalLabel,
      reasonNoneLabel,
      deauthorizeReasonModalBtn,
    } = insuredAccessLabels;
    const enabledTncBtn =
      agreeLoseAxaGoalData && agreeClaimSubmission && agreeAssistInsured;

    return isLoading ? (
      <LoadingView />
    ) : (
      <div className="insured-access emma-stylesheet-grid-system">
        {!error ? (
          <>
            {!isApp() && (
              <CustomerProfileTitle
                customerTitle={pageTitle ? resolveLocalizedText(pageTitle) : ''}
              />
            )}
            <div className="policy-container">
              <div className="policy-list-header">
                {policyListHeader ? resolveLocalizedText(policyListHeader) : ''}
              </div>
              <div className="policy-list-desc">
                {policyListDesc ? resolveLocalizedText(policyListDesc) : ''}
              </div>

              <div className="policy-list-wrapper mobile-vp">
                {policyList &&
                  policyList.map(
                    (
                      { policy, policyRiders, policyDetail, isLoading, error },
                      index,
                    ) => (
                      <InsuredAccessCard
                        key={index}
                        label={insuredAccessLabels}
                        policy={policy}
                        policyRiders={policyRiders}
                        policyDetail={policyDetail}
                        isLoading={isLoading}
                        lastUpdated={accessCustState[policy.policyNumber]}
                        lastDeactivation={
                          deactivationCustState[policy.policyNumber]
                        }
                        error={error}
                        onClick={() => {
                          this.onExpand(
                            policy.policyNumber,
                            policy.entityCode,
                            policyDetail,
                          );
                        }}
                        onClickAuthorize={() => {
                          this.handleAuthorize(policy.policyNumber);
                        }}
                        onClickMenu={() => {
                          this.handleMenu(policy.policyNumber);
                        }}
                        onClickDeauthorize={() => {
                          this.handleDeauthorize(policy.policyNumber);
                        }}
                        onClickRemindInsured={() => {
                          this.handleSharing(
                            policy.policyNumber,
                            policy.insuredAccessFlag,
                          );
                        }}
                        showDeauthorizeMenu={policy.policyNumber === showMenu}
                      />
                    ),
                  )}
              </div>
              <div className="policy-list-wrapper large-vp row">
                <div className="col-6 first-col">
                  {policyList &&
                    policyList.map(
                      (
                        {
                          policy,
                          policyRiders,
                          policyDetail,
                          isLoading,
                          error,
                        },
                        index,
                      ) => {
                        if (index % 2 === 0) {
                          return (
                            <InsuredAccessCard
                              key={index}
                              label={insuredAccessLabels}
                              policy={policy}
                              policyRiders={policyRiders}
                              policyDetail={policyDetail}
                              isLoading={isLoading}
                              lastUpdated={accessCustState[policy.policyNumber]}
                              lastDeactivation={
                                deactivationCustState[policy.policyNumber]
                              }
                              error={error}
                              onClick={() => {
                                this.onExpand(
                                  policy.policyNumber,
                                  policy.entityCode,
                                  policyDetail,
                                );
                              }}
                              onClickAuthorize={() => {
                                this.handleAuthorize(policy.policyNumber);
                              }}
                              onClickMenu={() => {
                                this.handleMenu(policy.policyNumber);
                              }}
                              onClickDeauthorize={() => {
                                this.handleDeauthorize(policy.policyNumber);
                              }}
                              onClickRemindInsured={() => {
                                this.handleSharing(
                                  policy.policyNumber,
                                  policy.insuredAccessFlag,
                                );
                              }}
                              showDeauthorizeMenu={
                                policy.policyNumber === showMenu
                              }
                            />
                          );
                        }
                        return null;
                      },
                    )}
                </div>
                <div className="col-6 second-col">
                  {policyList &&
                    policyList.map(
                      (
                        {
                          policy,
                          policyRiders,
                          policyDetail,
                          isLoading,
                          error,
                        },
                        index,
                      ) => {
                        if (index % 2 === 1) {
                          return (
                            <InsuredAccessCard
                              key={index}
                              label={insuredAccessLabels}
                              policy={policy}
                              policyRiders={policyRiders}
                              policyDetail={policyDetail}
                              isLoading={isLoading}
                              lastUpdated={accessCustState[policy.policyNumber]}
                              lastDeactivation={
                                deactivationCustState[policy.policyNumber]
                              }
                              error={error}
                              onClick={() => {
                                this.onExpand(
                                  policy.policyNumber,
                                  policy.entityCode,
                                  policyDetail,
                                );
                              }}
                              onClickAuthorize={() => {
                                this.handleAuthorize(policy.policyNumber);
                              }}
                              onClickMenu={() => {
                                this.handleMenu(policy.policyNumber);
                              }}
                              onClickDeauthorize={() => {
                                this.handleDeauthorize(policy.policyNumber);
                              }}
                              onClickRemindInsured={() => {
                                this.handleSharing(
                                  policy.policyNumber,
                                  policy.insuredAccessFlag,
                                );
                              }}
                              showDeauthorizeMenu={
                                policy.policyNumber === showMenu
                              }
                            />
                          );
                        }
                        return null;
                      },
                    )}
                </div>
              </div>
            </div>
          </>
        ) : (
          <CustomerProfileError
            label={insuredAccessLabels}
            tryAgainCallback={this.resetPage}
            callCsCallback={this.handleContactUs}
          />
        )}
        <Modal show={tncModal}>
          <ModalHeader>
            {tncModalTitle ? resolveLocalizedText(tncModalTitle) : ''}
          </ModalHeader>
          <ModalBody>
            <div
              dangerouslySetInnerHTML={{
                __html: memoSanitize(
                  tncModalContent ? resolveLocalizedText(tncModalContent) : '',
                ),
              }}
            ></div>
          </ModalBody>
          <ModalFooter>
            <div className="dialog-footer-button">
              <button
                data-enable-ga
                data-ga-type="button"
                disabled={accessIsLoading}
                className={
                  accessIsLoading
                    ? 'emma-stylesheet-primary-secondary-default-disabled-button'
                    : 'emma-stylesheet-primary-default-button'
                }
                onClick={() => {
                  trackPartnerServiceDisclaimer(
                    TrackPartnerServiceDisclaimerIcon.INSURED_ACCESS,
                  );
                  updateInsuredAccess(
                    selectedPolicy,
                    'Y',
                    insuredAccessCustKey,
                    () => {
                      this.setState({ tncModal: false });
                      controlTopbarOverlay(false);
                      showBackButton();
                      showCloseButton();
                    },
                  );
                }}
              >
                {accessIsLoading && <img src={loadingIcon} alt="loading" />}
                {tncModalAgreeBtn ? resolveLocalizedText(tncModalAgreeBtn) : ''}
              </button>
              <button
                data-enable-ga
                data-ga-type="button"
                className="emma-stylesheet-primary-ghost-button"
                onClick={() => {
                  this.setState({ tncModal: false });
                  controlTopbarOverlay(false);
                  showBackButton();
                  showCloseButton();
                }}
              >
                {tncModalCancelBtn
                  ? resolveLocalizedText(tncModalCancelBtn)
                  : ''}
              </button>
            </div>
          </ModalFooter>
        </Modal>
        <div className="deauthorize-tnc-modal">
          <Dialog show={deauthorizeTncModal}>
            <DialogHeader>
              {deauthorizeTncModalTitle
                ? resolveLocalizedText(deauthorizeTncModalTitle)
                : ''}
            </DialogHeader>
            <DialogBody>
              <div className="description">
                {deauthorizeTncModalDesc
                  ? resolveLocalizedText(deauthorizeTncModalDesc)
                  : ''}
              </div>
              <div className="emma-stylesheet-checkbox">
                <input
                  id="agreeLoseAxaGoalData"
                  name="agreeLoseAxaGoalData"
                  type="checkbox"
                  value="Y"
                  onChange={this.onChangeCheckbox}
                  checked={agreeLoseAxaGoalData ? true : false}
                />
                <label htmlFor="agreeLoseAxaGoalData">
                  {agreeLoseAxaGoalDataLabel
                    ? resolveLocalizedText(agreeLoseAxaGoalDataLabel)
                    : ''}
                </label>
              </div>
              <div className="emma-stylesheet-checkbox">
                <input
                  id="agreeClaimSubmission"
                  name="agreeClaimSubmission"
                  type="checkbox"
                  value="Y"
                  onChange={this.onChangeCheckbox}
                  checked={agreeClaimSubmission ? true : false}
                />
                <label htmlFor="agreeClaimSubmission">
                  {agreeClaimSubmissionLabel
                    ? resolveLocalizedText(agreeClaimSubmissionLabel)
                    : ''}
                </label>
              </div>
              <div className="emma-stylesheet-checkbox">
                <input
                  id="agreeAssistInsured"
                  name="agreeAssistInsured"
                  type="checkbox"
                  value="Y"
                  onChange={this.onChangeCheckbox}
                  checked={agreeAssistInsured ? true : false}
                />
                <label htmlFor="agreeAssistInsured">
                  {agreeAssistInsuredLabel
                    ? resolveLocalizedText(agreeAssistInsuredLabel)
                    : ''}
                </label>
              </div>
            </DialogBody>
            <DialogFooter>
              <div className="dialog-footer-button">
                <button
                  data-enable-ga
                  data-ga-type="button"
                  disabled={!enabledTncBtn}
                  className={
                    enabledTncBtn
                      ? 'emma-stylesheet-primary-default-button'
                      : 'emma-stylesheet-primary-secondary-default-disabled-button'
                  }
                  onClick={() => {
                    this.setState({
                      deauthorizeTncModal: false,
                      deauthorizeReasonModal: true,
                      agreeLoseAxaGoalData: false,
                      agreeClaimSubmission: false,
                      agreeAssistInsured: false,
                    });
                  }}
                >
                  {tncModalAgreeBtn
                    ? resolveLocalizedText(tncModalAgreeBtn)
                    : ''}
                </button>
                <button
                  data-enable-ga
                  data-ga-type="button"
                  className="emma-stylesheet-primary-ghost-button"
                  onClick={() => {
                    this.setState({
                      deauthorizeTncModal: false,
                      agreeLoseAxaGoalData: false,
                      agreeClaimSubmission: false,
                      agreeAssistInsured: false,
                    });

                    controlTopbarOverlay(false);
                    showBackButton();
                    showCloseButton();
                  }}
                >
                  {tncModalCancelBtn
                    ? resolveLocalizedText(tncModalCancelBtn)
                    : ''}
                </button>
              </div>
            </DialogFooter>
          </Dialog>
        </div>
        <div className="deauthorize-reason-modal">
          <Dialog show={deauthorizeReasonModal}>
            <DialogHeader>
              {deauthorizeReasonModalTitle
                ? resolveLocalizedText(deauthorizeReasonModalTitle)
                : ''}
            </DialogHeader>
            <DialogBody>
              <div className="emma-stylesheet-radio">
                <input
                  id="reasonMistake"
                  name="reasonRadio"
                  type="radio"
                  value="reasonMistake"
                  checked={reasonRadio === 'reasonMistake'}
                  onChange={this.onChangeRadio}
                />
                <label htmlFor="reasonMistake">
                  {reasonMistakeLabel
                    ? resolveLocalizedText(reasonMistakeLabel)
                    : ''}
                </label>
              </div>
              <div className="emma-stylesheet-radio">
                <input
                  id="reasonLossDevice"
                  name="reasonRadio"
                  type="radio"
                  value="reasonLossDevice"
                  checked={reasonRadio === 'reasonLossDevice'}
                  onChange={this.onChangeRadio}
                />
                <label htmlFor="reasonLossDevice">
                  {reasonLossDeviceLabel
                    ? resolveLocalizedText(reasonLossDeviceLabel)
                    : ''}
                </label>
              </div>
              <div className="emma-stylesheet-radio">
                <input
                  id="reasonPersonal"
                  name="reasonRadio"
                  type="radio"
                  value="reasonPersonal"
                  checked={reasonRadio === 'reasonPersonal'}
                  onChange={this.onChangeRadio}
                />
                <label htmlFor="reasonPersonal">
                  {reasonPersonalLabel
                    ? resolveLocalizedText(reasonPersonalLabel)
                    : ''}
                </label>
              </div>
              <div className="emma-stylesheet-radio">
                <input
                  id="reasonNone"
                  name="reasonRadio"
                  type="radio"
                  value="reasonNone"
                  checked={reasonRadio === 'reasonNone'}
                  onChange={this.onChangeRadio}
                />
                <label htmlFor="reasonNone">
                  {reasonNoneLabel ? resolveLocalizedText(reasonNoneLabel) : ''}
                </label>
              </div>
            </DialogBody>
            <DialogFooter>
              <div>
                <button
                  data-enable-ga
                  data-ga-type="button"
                  disabled={reasonRadio === '' || accessIsLoading}
                  className={
                    reasonRadio === '' || accessIsLoading
                      ? 'emma-stylesheet-primary-secondary-default-disabled-button'
                      : 'emma-stylesheet-primary-default-button'
                  }
                  onClick={() => {
                    trackPartnerServiceDisclaimer(
                      TrackPartnerServiceDisclaimerIcon.INSURED_ACCESS,
                    );
                    updateInsuredAccess(
                      deauthorizePolicy,
                      'N',
                      deactivationCustKey,
                      () => {
                        this.setState({
                          deauthorizeReasonModal: false,
                          reasonRadio: '',
                        });
                        controlTopbarOverlay(false);
                        showBackButton();
                        showCloseButton();
                      },
                    );
                  }}
                >
                  {accessIsLoading && <img src={loadingIcon} alt="loading" />}
                  {deauthorizeReasonModalBtn
                    ? resolveLocalizedText(deauthorizeReasonModalBtn)
                    : ''}
                </button>
              </div>
            </DialogFooter>
          </Dialog>
        </div>
        <EmmaErrorModal />
      </div>
    );
  }

  static mapStateToProps(state: any) {
    const insuredAccessLabels = getInsuredAccessLabels(state);
    const policyList = getInsuredPolicyList(state);
    const isLoading = getIsLoading(state);
    const accessIsLoading = getAccessIsLoading(state);
    const accessCustState = getAccessCustState(state);
    const deactivationCustState = getDeactivationCustState(state);
    const error = getError(state);

    return {
      insuredAccessLabels,
      policyList,
      isLoading,
      accessIsLoading,
      accessCustState,
      deactivationCustState,
      error,
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {
      fetchInsuredPolicyList: () => dispatch(fetchInsuredPolicyList()),
      updateInsuredAccess: (
        policyNumber: string,
        insuredAccessFlag: string,
        custKey: string,
        callback: () => void,
      ) =>
        dispatch(
          updateInsuredAccess(
            policyNumber,
            insuredAccessFlag,
            custKey,
            callback,
          ),
        ),
      resetInsuredAccessPage: () => dispatch(resetInsuredAccessPage()),
      fetchInsuredPolicyDetail: (policyNumber: string, entityCode: string) =>
        dispatch(fetchInsuredPolicyDetail(policyNumber, entityCode)),
      showInsuredShare: () =>
        dispatch({
          type: INSURED_SHARE,
        }),
      fetchInsuredAccessLastUpdated: (custKey: string, destination: string) =>
        dispatch(fetchInsuredAccessLastUpdated(custKey, destination)),
    };
  }
}

export default connect(
  InsuredAccessContainer.mapStateToProps,
  InsuredAccessContainer.mapDispatchToProps,
)(InsuredAccessContainer);
